import React, { useState } from 'react'
import styles from './styles.module.css'

function Quantities({ record }) {
  const [isExpanded, setIsExpanded] = useState(false)

  const quantities = record?.quantities || [] // Fallback to an empty array if quantities doesn't exist

  return (
    <section className={styles?.quantitiesContainer}>
      <h2 className={styles?.quantitiesTitle}>Quantities</h2>

      <ul className={styles?.listQuantities}>
        {quantities.length === 0 ? (
          <div style={{ width: '340px' }}>
            <span className={styles?.quantitiesValue}>N/A</span>
          </div>
        ) : (
          quantities
            ?.slice(0, isExpanded ? quantities.length : 3)
            ?.map((quantity, index) => (
              <li key={index} className={styles?.quantitiesContainerItem}>
                <span className={styles?.quantitiesType}>Value</span>
                <span className={styles?.quantitiesValue}>
                  {quantity?.value || 'N/A'}
                </span>
              </li>
            ))
        )}
      </ul>

      {quantities?.length > 3 && (
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className={styles?.expandButtonQuantities}
          type='button'
        >
          {isExpanded ? 'Show Less' : `Expand All (${quantities.length})`}
        </button>
      )}
    </section>
  )
}

export default Quantities
